const EditInvoiceDialogStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      boxShadow: '0 8px 40px rgba(0, 0, 0, 0.12)',
      overflow: 'hidden',
      maxHeight: '90vh'
    }
  },

  dialogTitle: {
    p: 3,
    borderBottom: '2px solid #e5e7eb',
    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiTypography-h6': {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: '#1976d2'
    }
  },

  closeButton: {
    color: 'grey.500',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.08)',
      color: 'error.main',
      transform: 'rotate(90deg)'
    }
  },

  dialogContent: {
    p: 3,
    backgroundColor: '#fafbfc'
  },

  warningAlert: {
    mb: 3,
    borderRadius: '12px',
    border: '2px solid #FFA726',
    backgroundColor: '#FFF8E1',
    boxShadow: '0 2px 12px rgba(255, 167, 38, 0.2)',
    '& .MuiAlert-message': {
      width: '100%'
    }
  },

  errorAlert: {
    mb: 3,
    borderRadius: '12px',
    border: '2px solid #EF5350',
    backgroundColor: '#FFEBEE',
    boxShadow: '0 2px 12px rgba(239, 83, 80, 0.2)',
    '& .MuiAlert-message': {
      width: '100%'
    }
  },

  infoAlert: {
    borderRadius: '12px',
    border: '2px solid #42A5F5',
    backgroundColor: '#E3F2FD',
    boxShadow: '0 2px 12px rgba(66, 165, 245, 0.2)'
  },

  detailsBox: {
    bgcolor: '#f8f9fa',
    p: 2.5,
    borderRadius: '12px',
    mb: 2,
    border: '1px solid #e5e7eb',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#d1d5db',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }
  },

  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#ffffff',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      '& fieldset': {
        borderColor: '#e5e7eb',
        borderWidth: '2px',
        transition: 'all 0.3s ease'
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
        boxShadow: '0 0 0 3px rgba(156, 163, 175, 0.1)'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
        borderWidth: '2px',
        boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.1)'
      },
      '&.Mui-disabled': {
        backgroundColor: '#f3f4f6',
        '& fieldset': {
          borderColor: '#e5e7eb'
        }
      }
    },
    '& .MuiInputLabel-root': {
      fontWeight: 500,
      fontSize: '0.95rem',
      '&.Mui-focused': {
        color: '#1976d2',
        fontWeight: 600
      }
    },
    '& .MuiFormHelperText-root': {
      fontSize: '0.813rem',
      fontWeight: 500,
      marginTop: '6px'
    },
    '& .MuiInputBase-input': {
      fontWeight: 500
    }
  },

  textFieldError: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#EF5350',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#E53935'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D32F2F'
      }
    },
    '& .MuiFormHelperText-root': {
      color: '#D32F2F',
      fontWeight: 600
    }
  },

  gridContainer: {
    mt: 1
  },

  dialogActions: {
    p: 2.5,
    gap: 2,
    borderTop: '2px solid #e5e7eb',
    backgroundColor: '#f8f9fa',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start'
  },

  cancelButton: {
    borderRadius: '10px',
    px: 3,
    py: 1.5,
    fontWeight: 600,
    fontSize: '0.95rem',
    color: '#6b7280',
    backgroundColor: 'transparent',
    border: 'none',
    transition: 'all 0.2s ease',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#f3f4f6',
      color: '#374151'
    },
    '&:disabled': {
      opacity: 0.5,
      color: '#9ca3af'
    }
  },

  saveButton: {
    borderRadius: '10px',
    px: 4,
    py: 1.5,
    fontWeight: 600,
    fontSize: '1rem',
    background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
    boxShadow: '0 3px 12px rgba(25, 118, 210, 0.35)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    textTransform: 'none',
    minWidth: '140px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
      transition: 'left 0.5s ease'
    },
    '&:hover': {
      background: 'linear-gradient(135deg, #1565c0 0%, #0c3d8a 100%)',
      boxShadow: '0 6px 20px rgba(25, 118, 210, 0.45)',
      transform: 'translateY(-2px)',
      '&::before': {
        left: '100%'
      }
    },
    '&:active': {
      transform: 'translateY(0px)'
    },
    '&.Mui-disabled': {
      background: '#e0e0e0',
      color: '#9e9e9e',
      boxShadow: 'none',
      opacity: 0.7
    }
  },

  reprocessButton: {
    background: 'linear-gradient(135deg, #FFA726 0%, #FB8C00 100%)',
    '&:hover': {
      background: 'linear-gradient(135deg, #FB8C00 0%, #F57C00 100%)',
      boxShadow: '0 4px 16px rgba(255, 167, 38, 0.4)'
    }
  },

  loadingIcon: {
    animation: 'spin 1s linear infinite',
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    }
  },

  warningIcon: {
    fontSize: '28px',
    color: '#FFA726',
    animation: 'pulse 2s ease-in-out infinite',
    '@keyframes pulse': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0.6 }
    }
  },

  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
  },

  sectionTitle: {
    fontWeight: 600,
    fontSize: '0.95rem',
    color: '#374151',
    mb: 1
  },

  instructionsList: {
    mt: 1,
    '& li': {
      marginBottom: '8px',
      fontSize: '0.875rem',
      lineHeight: 1.6
    }
  },

  successButton: {
    borderRadius: '10px',
    px: 3,
    py: 1.5,
    fontWeight: 600,
    background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
    '&:hover': {
      background: 'linear-gradient(135deg, #1b5e20 0%, #0d3d10 100%)',
      boxShadow: '0 4px 16px rgba(46, 125, 50, 0.4)'
    }
  }
};

export default EditInvoiceDialogStyles;